import React, { useCallback, useState } from 'react'
import type { ConfirmDialogOptions, UseConfirmDialogReturn } from './useConfirmDialog'
import { ConfirmDialogModal } from './ConfirmDialogModal.web'

export { type ConfirmDialogOptions }

export function useConfirmDialog(): UseConfirmDialogReturn {
  const [pending, setPending] = useState<ConfirmDialogOptions | null>(null)

  const showConfirm = useCallback((options: ConfirmDialogOptions) => {
    setPending(options)
  }, [])

  const handleConfirm = useCallback(() => {
    pending?.onConfirm()
    setPending(null)
  }, [pending])

  const handleCancel = useCallback(() => {
    pending?.onCancel?.()
    setPending(null)
  }, [pending])

  const dialogPortal = pending
    ? React.createElement(ConfirmDialogModal, {
        visible: true,
        title: pending.title,
        message: pending.message,
        cancelText: pending.cancelText,
        confirmText: pending.confirmText,
        onConfirm: handleConfirm,
        onCancel: handleCancel
      })
    : null

  return { showConfirm, dialogPortal }
}
